import {useEffect} from '@wordpress/element'
import {useStripe} from "@stripe/react-stripe-js";
import {handleCardAction} from "../util";
import {useProcessCheckoutError} from "./use-process-checkout-error";

export const useAfterProcessingPayment = (
    {
        name,
        eventRegistration,
        emitResponse,
        activePaymentMethod,
        shouldSavePayment = false,
        messageContext = null
    }) => {
    const stripe = useStripe();
    const {onCheckoutSuccess} = eventRegistration;

    useEffect(() => {
        let unsubscribe = onCheckoutSuccess(async ({redirectUrl}) => {
            if (name === activePaymentMethod) {
                //check if response is in redirect. If so, open modal
                return await handleCardAction({
                    redirectUrl,
                    emitResponse,
                    savePaymentMethod: shouldSavePayment
                });
            }
            return null;
        })
        return () => unsubscribe()
    }, [
        stripe,
        onCheckoutSuccess,
        activePaymentMethod,
        shouldSavePayment
    ]);
}